import { toast } from "react-toastify";

const SIGNIN_PATH = "/session/signin";

// A failed sign-in surfaces its own error on the form, so it must not bounce the
// page. Note auth/forgot-pwd is NOT listed: it is an authenticated endpoint, so a
// 401 there really is an expired token and should log the user out.
const AUTH_URLS = ["auth"];

// Several requests can fail together (e.g. a page loading list + details),
// this keeps them from stacking toasts and redirects.
let isRedirecting = false;

const isAuthRequest = (url = "") => {
  const path = String(url).split("?")[0].replace(/^\/+|\/+$/g, "");
  return AUTH_URLS.includes(path);
};

export const handleUnauthorized = (err) => {
  if (err?.response?.status !== 401) return;
  if (isAuthRequest(err?.config?.url)) return;
  if (isRedirecting) return;
  if (window.location.pathname === SIGNIN_PATH) return;

  isRedirecting = true;

  toast.error(err?.response?.data?.message || "Session expired. Please login again.", {
    autoClose: 2000
  });

  localStorage.clear();

  // full reload so redux/auth context start clean on the login page
  setTimeout(() => window.location.replace(SIGNIN_PATH), 1200);
};
